import { render, staticRenderFns } from "./ChallengeTopicMessage.vue?vue&type=template&id=43cc8f18"
import script from "./ChallengeTopicMessage.vue?vue&type=script&lang=ts"
export * from "./ChallengeTopicMessage.vue?vue&type=script&lang=ts"
import style0 from "./ChallengeTopicMessage.vue?vue&type=style&index=0&id=43cc8f18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports